//@flow

import React from "react";

export default function compareABcolorful(valA: number, valB: number, displayVal: number | string) {
  let cls = "";
  if (valA > valB) cls = "text-negative";
  else if (valA > valB) cls = "text-negative";
  else cls = "text-warning";
  return <div className={cls}>{displayVal}</div>;
}
